import React from 'react';
import {useStyles} from "../BillingPeriod.style";
import clsx from "clsx";
import BillingPeriodRowProperties from "./BillingPeriodRowProperties";
import ShowDate from "../../../shared_components/Info/ShowDate/ShowDate";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ExpandoMenu from "../../../ui_components/ExpandoMenu/ExpandoMenu";
import ShowArticleDescription from '../../../shared_components/Info/ShowArticleDescription/ShowArticleDescription';
import NewBillingPeriodButton from '../../../shared_components/Buttons/NewBillingPeriodButton/NewBillingPeriodButton';
import RemoveBillingPeriodButton from '../../../shared_components/Buttons/RemoveBillingPeriodButton/RemoveBillingPeriodButton';
import ShowBillingPeriodStatus from '../../../shared_components/Info/ShowBillingPeriodStatus/ShowBillingPeriodStatus';
import CloseBillingPeriodButton from '../../../shared_components/Buttons/CloseBillingPeriodButton/CloseBillingPeriodButton';
import { useNavigate } from 'react-router';
import AllowAccess from '../../../shared_components/Access/AllowAccess/AllowAccess';
import Access from '../../../shared_components/Access/AllowAccess/Access';
import Link from '../../../ui_components/Link/Link';
import BillBillingPeriodButton from '../../../shared_components/Buttons/BillBillingPeriodButton/BillBillingPeriodButton';

const BillingPeriodRowMedium: React.FC<BillingPeriodRowProperties> = ({
                                                            billingPeriod,
                                                            onUpdate = () => {
                                                            },
                                                        }) => {


    const classes = useStyles();
    const navigate = useNavigate();

    const handleOnclick = () => {
        navigate(`billing-period-agency-closure/${billingPeriod.id}`, { replace: true });
    }

    return (
        <div
            className={clsx(classes.billing_period_info_container)}>
            <ShowDate label={'Inicio'} timestamp={billingPeriod.startDate} showTime={false}/>
            <ShowDate label={'Fin'} timestamp={billingPeriod.endDate} showTime={false}/>
            <ShowArticleDescription description={billingPeriod.description}/>
            <div className={classes.status_container}>
                <ShowBillingPeriodStatus status={billingPeriod.status}/>
                {(billingPeriod.status === 'CLOSED' || billingPeriod.status === 'BILLED') && <div>
                    <Link text={'Ver detalles'} onClick={handleOnclick}></Link>
                </div>}
            </div>
            
            <AllowAccess any={[Access.CREATE_BILLING_PERIOD]}>
                <ExpandoMenu>
                    <>
                        <NewBillingPeriodButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            billingPeriodId={billingPeriod.id}
                            showText
                            type={ButtonType.SECONDARY}
                        />
                        {billingPeriod.status === 'OPEN' && <CloseBillingPeriodButton
                            onSave={onUpdate}
                            billingPeriodId={billingPeriod.id}
                            size={ButtonSize.SMALL}
                            showText
                            type={ButtonType.SECONDARY}
                        />}
                        {billingPeriod.status === 'CLOSED' && <BillBillingPeriodButton
                            onSave={onUpdate}
                            billingPeriodId={billingPeriod.id}
                            size={ButtonSize.SMALL}
                            showText
                            type={ButtonType.SECONDARY}
                        />}
                        <RemoveBillingPeriodButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            billingPeriod={billingPeriod}
                            showText
                            type={ButtonType.SECONDARY}
                        />
                    </>
                </ExpandoMenu>
            </AllowAccess>
        </div>
    )
}

export default BillingPeriodRowMedium;
